const sizes = {
    1: 'w-5 h-5',
    2: 'w-8 h-8',
    3: 'w-10 h-10',
    4: 'w-12 h-12',
    5: 'w-14 h-14',
    6: 'w-16 h-16',
    7: 'w-20 h-20',
    8: 'w-24 h-24',
    9: 'w-28 h-28',
    10: 'w-32 h-32',
    11: 'w-36 h-36',
    12: 'w-40 h-40'
}


export default sizes;